import type { ReactNode } from "react"

interface AssignmentCardProps {
  title: string
  children: ReactNode
}

export const AssignmentCard = ({ title, children }: AssignmentCardProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-3 w-full h-full bg-white border border-neutral-200 rounded-lg p-6 shadow-sm 2xl:col-span-1">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="font-text-sm-medium text-neutral-800">{title}</span>
        </div>
      </div>
      {children}
    </div>
  )
}
